import {http} from './config';

export default {
    listCredentials: (params = {}) => http.get('api/v1/integration-credentials', {params}),
    listVentures: (params = {}) => http.get('api/v1/app-facilita/ventures', {params}),
};
